import { render, staticRenderFns } from "./UploadImage.v2.vue?vue&type=template&id=aa6f9d6e&scoped=true&"
import script from "./UploadImage.v2.vue?vue&type=script&lang=js&"
export * from "./UploadImage.v2.vue?vue&type=script&lang=js&"
import style0 from "./UploadImage.v2.vue?vue&type=style&index=0&id=aa6f9d6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa6f9d6e",
  null
  
)

export default component.exports